import React from 'react';
import styled, { keyframes } from 'styled-components';
import { colorAccent, colorBorder, colorBackgroundBody } from '../../../theme/palette';
/**
 * Componente de loading para tabelas
 * 
 * @param {Object} props
 * @param {number} props.rows - Número de linhas de skeleton
 * @param {number} props.columns - Número de colunas de skeleton
 */

const TableLoading = ({
  rows = 5,
  columns = 6
}) => {
  return <LoadingContainer>
      <LoadingTable>
        <LoadingHeader>
          <LoadingRow>
            {Array.from({
            length: columns
          }).map((_, index) => <LoadingHeaderCell key={index}>
                <SkeletonBox width="80%" height="16px" />
              </LoadingHeaderCell>)}
          </LoadingRow>
        </LoadingHeader>
        <LoadingBody>
          {Array.from({
          length: rows
        }).map((_, rowIndex) => <LoadingRow key={rowIndex}>
              {Array.from({
            length: columns
          }).map((_, colIndex) => <LoadingCell key={colIndex}>
                  <SkeletonBox width={`${60 + Math.random() * 40}%`} height="14px" />
                </LoadingCell>)}
            </LoadingRow>)}
        </LoadingBody>
      </LoadingTable>
    </LoadingContainer>;
}; // Animações


const shimmer = keyframes`
  0% {
    background-position: -200px 0;
  }
  100% {
    background-position: calc(200px + 100%) 0;
  }
`; // Estilos

const LoadingContainer = styled.div`
  overflow-x: auto;
  overflow-y: auto;
  max-height: 600px;
  border: 1px solid ${colorBorder};
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  background: white;
`;
const LoadingTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  white-space: nowrap;
`;
const LoadingHeader = styled.thead`
  background-color: ${colorBackgroundBody};
  position: sticky;
  top: 0;
  z-index: 10;
`;
const LoadingBody = styled.tbody``;
const LoadingRow = styled.tr``;
const LoadingHeaderCell = styled.th`
  padding: 12px 16px;
  text-align: left;
  border-bottom: 2px solid ${colorBorder};
  background-color: ${colorBackgroundBody};
`;
const LoadingCell = styled.td`
  padding: 12px 16px;
  border-bottom: 1px solid ${colorBorder};
  vertical-align: middle;
`;
const SkeletonBox = styled.div.attrs(props => ({
  style: {
    width: props.width || '100%',
    height: props.height || '16px'
  }
}))`
  background: linear-gradient(
    90deg,
    #f0f0f0 25%,
    #e0e0e0 50%,
    #f0f0f0 75%
  );
  background-size: 200px 100%;
  animation: ${shimmer} 1.5s infinite;
  border-radius: 4px;
`;
export default TableLoading;